import { render, staticRenderFns } from "./UserEditDetails.vue?vue&type=template&id=31892128&scoped=true&"
import script from "./UserEditDetails.vue?vue&type=script&lang=js&"
export * from "./UserEditDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserEditDetails.vue?vue&type=style&index=0&id=31892128&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31892128",
  null
  
)

export default component.exports